import React from 'react';

import DeliveryIcon from '../../../assets/icons/delivery-car.svg';
import CloseIcon from '../../../assets/icons/closeModal.svg';
import InfoIcon from '../../../assets/icons/info.svg';

import { deliveryMethods } from '../../../constants/deliveryData';

import './Delivery.scss';

interface IDeliveryProps {
  onClose: () => void;
}

const Delivery: React.FC<IDeliveryProps> = ({ onClose }): JSX.Element => {
  return (
    <div className="deliveryModal">
      <div className="deliveryModal__left">
        <div className="deliveryModal__wrapper">
          <div className="deliveryModal__icon">
            <DeliveryIcon />
          </div>
          <div className="deliveryModal__close" onClick={() => onClose()}>
            <CloseIcon />
          </div>
          <h2 className="deliveryModal__title">Доставка</h2>
          <p className="deliveryModal__description">
            Після здійснення вами замовлення на нашому сайті, з вами звяжеться наш менеджер, для уточнення деталей та узгодження зручного
            для вас варіанту оплати та доставки товарів
          </p>
        </div>
        <div className="deliveryModal__wrapper">
          <div className="deliveryModal__info">
            <InfoIcon />
            <p>Ви можете звернутися до нашої компанії і ми підберемо оптимальний для вас спосіб оплати та доставки товарів</p>
          </div>
        </div>
      </div>
      <div className="deliveryModal__right">
        <div className="deliveryModal__wrapper">
          <div className="deliveryModal__methods-item">
            <p className="deliveryModal__methods-counter">01</p>
            <p>{deliveryMethods[0].title}</p>
          </div>
        </div>
        <div className="deliveryModal__wrapper">
          <div className="deliveryModal__methods-item">
            <p className="deliveryModal__methods-counter">02</p>
            <p>{deliveryMethods[1].title}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Delivery;
